import React, { useState, useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import Keybord from './keybord';
function FormModal({ showModal, onClick, onClose }) {
  const [name, setName] = useState('');
  const [error, toggleError] = useState(false);
  const handleSubmit = useCallback(
    (e) => {
      if (name) {
        toggleError(false);
        onClick(name);
      } else {
        toggleError(true);
      }
      e.preventDefault();
    },
    [name]
  );
  const handleChange = useCallback((e) => {
    setName(e.target.value);
  }, []);
  return (
    <div className={'formModalContent'} data-show={showModal} onClick={onClose}>
      <div className="formModalInner" onClick={(e) => e.stopPropagation()}>
        <button type="submit" onTouchStart={() => {}} className="closeBtn" onClick={onClose}>
          <img src={'assets/img/btn-close.png'} alt="close" />
        </button>
        <p className="modalTitle">
          <img src={'assets/img/txt-name.png'} alt="キミの名前を教えてね！" className="txtName" />
        </p>
        <form onSubmit={handleSubmit}>
          <input type="text" maxLength="10" value={name} onChange={handleChange} className="inputName" />
          <button type="submit" onTouchStart={() => {}} className="questionBtn questionNextBtn">
            <img src={'assets/img/btn-next2.png'} alt="次へ" />
          </button>
        </form>
        {error && <p className="txtError">名前を入力してください。</p>}
      </div>
      {!isMobile && (
        <Keybord
          name={name}
          onChange={(name) => {
            setName(name);
          }}
        />
      )}
    </div>
  );
}

export default FormModal;
